export default {
  methods: {
    showLoader(options = {}) {
      this.$store.dispatch("showLoader", { ...options, overlay: false });
    },
    showOverlayLoader(options = {}) {
      this.$store.dispatch("showLoader", {
        ...options,
        overlay: true,
        overlayBlur: "0px",
      });
    },
    showBlurLoader(options = {}) {
      this.$store.dispatch("showLoader", {
        ...options,
        overlay: true,
        overlayBlur: options.overlayBlur || "3px",
      });
    },
    hideLoader() {
      this.$store.dispatch("hideLoader");
    },

    async withLoader(
      asyncFunction,
      message = "Загрузка...",
      overlay = false,
      blur = false,
    ) {
      try {
        if (overlay) {
          if (blur) {
            this.showBlurLoader({ message });
          } else {
            this.showOverlayLoader({ message });
          }
        } else {
          this.showLoader({ message });
        }
        const result = await asyncFunction();
        return result;
      } finally {
        this.hideLoader();
      }
    },
  },
};
